import Dummy from "components/Dummy";
import P from "components/P";
import Container from "layouts/container/Container";
import Inline from "layouts/container/Inline";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { addCommas } from "shared/utils/Utils";
import { storeRequester } from "App";


function MobileTrackOrderDetail(props) {
    const location = useLocation();
    const { t } = useTranslation();
    const [orderData, setOrderData] = useState();
    const [isDate, setDate] = useState();
    useEffect(() => {
        if (location) {

            const date = location.state.data.created_at.split("T")[0]; // 날짜만 추출
            setDate(date);

            setOrderData(location.state.data);

        }

    }, [location])

    const getDisplayStatus = (status, payment_status, fulfillment_status) => {
        if (status === "pending" && ["awaiting", "captured"].includes(payment_status)) {
            if (fulfillment_status === "not_fulfilled") {
                return "상품 준비";
            } else if (fulfillment_status === "fulfilled") {
                return "배송 준비";
            } else if (fulfillment_status === "partially_shipped") {
                return "배송 중";
            }
        }
        return status;
    };

    const canCancelOrder = orderData &&
        orderData.status === "pending" &&
        orderData.payment_status === "awaiting" &&
        orderData.fulfillment_status === "not_fulfilled";



    const onCancelOrder = async () => {
        try {
            await storeRequester.cancelCustomerOrder(
                orderData.id,
                (response) => {
                    if (response.order) {
                        setOrderData(prevOrder => ({
                            ...prevOrder,
                            status: response.order.status,
                            payment_status: response.order.payment_status,
                            fulfillment_status: response.order.fulfillment_status
                        }));

                        toast.success(t("주문이 취소되었습니다."), {
                            autoClose: 2000,
                            position: toast.POSITION.BOTTOM_CENTER
                        });
                    } else {
                        toast.error(t("주문 취소에 실패했습니다."), {
                            autoClose: 2000,
                            position: toast.POSITION.BOTTOM_CENTER
                        });
                    }
                }
            );
        } catch (error) {
            console.error("Cancel order error:", error);
            toast.error(t("주문 취소 중 오류가 발생했습니다."), {
                autoClose: 2000,
                position: toast.POSITION.BOTTOM_CENTER
            });
        }
    };


    const onShippingStatusClick = (d) => {
        const trackingNumber = d.metadata.shipping; // 운송장 번호 가져오기

        if (!trackingNumber) {
            toast.error(t("운송장 번호가 존재하지 않습니다."), {
                autoClose: 1000,
                position: toast.POSITION.BOTTOM_CENTER,
            });
            return;
        }
        const trackingUrl = `https://trace.cjlogistics.com/next/tracking.html?wblNo=${trackingNumber}`;
        // 팝업창 열기
        window.open(trackingUrl, "_blank");
    };
    return (
        <Container backgroundColor={"rgba(247,247,247,1)"} padding={"0 0 30px 0"}>
            <Container width={"95%"}>
                <VerticalFlex>
                    <FlexChild>
                        <PaddingWrapper padding={"10px 0"}>
                            <HorizontalFlex>
                                <FlexChild>
                                    <Inline>
                                        <P weight={700} size={14}>{isDate && isDate} </P>
                                        <P weight={700} size={14}>주문</P>
                                    </Inline>

                                </FlexChild>
                                <FlexChild justifyContent={"flex-end"} width={"60%"}>
                                    <Inline>
                                        <P size={9}>주문번호 </P>
                                        <P size={9}>{orderData?.id.split("order_")}</P>
                                    </Inline>
                                </FlexChild>
                            </HorizontalFlex>
                        </PaddingWrapper>
                    </FlexChild>
                    <FlexChild>
                        <div style={{ backgroundColor: "white", padding: "15px", borderRadius: "10px" }}>
                            <VerticalFlex gap={15} flexStart>
                                <FlexChild>
                                    <P color={"black"} size={14} weight={700}>결제 정보</P>
                                </FlexChild>
                                <FlexChild>
                                    <VerticalFlex gap={5}>
                                        <FlexChild>
                                            <HorizontalFlex>
                                                <FlexChild>
                                                    <P size={16}>상품가격</P>
                                                </FlexChild>
                                                <FlexChild justifyContent={"flex-end"}>
                                                    <P size={16}>{addCommas(orderData?.subtotal)} </P>
                                                </FlexChild>
                                            </HorizontalFlex>
                                        </FlexChild>
                                        <FlexChild>
                                            <HorizontalFlex>
                                                <FlexChild>
                                                    <P size={16}>부가세</P>
                                                </FlexChild>
                                                <FlexChild justifyContent={"flex-end"}>
                                                    <P size={16}>{addCommas(orderData?.tax_total)} </P>
                                                </FlexChild>
                                            </HorizontalFlex>
                                        </FlexChild>
                                        <FlexChild>
                                            <HorizontalFlex>
                                                <FlexChild>
                                                    <P size={16}>배송비</P>
                                                </FlexChild>
                                                <FlexChild justifyContent={"flex-end"}>
                                                    <P size={16}>{addCommas(orderData?.shipping_total)} </P>
                                                </FlexChild>
                                            </HorizontalFlex>
                                        </FlexChild>
                                        <FlexChild>
                                            <HorizontalFlex>
                                                <FlexChild>
                                                    <P size={16}>포인트</P>
                                                </FlexChild>
                                                <FlexChild justifyContent={"flex-end"}>
                                                    <P size={16}>- {addCommas(orderData?.metadata.point)}</P>
                                                </FlexChild>
                                            </HorizontalFlex>
                                        </FlexChild>
                                    </VerticalFlex>
                                </FlexChild>
                                <FlexChild>
                                    <div style={{ width: "100%", height: "1px", backgroundColor: "#eee" }} />
                                </FlexChild>
                                <FlexChild>
                                    <HorizontalFlex>
                                        <FlexChild>
                                            <P size={16} weight={700}>총 결제금액</P>
                                        </FlexChild>
                                        <FlexChild justifyContent={"flex-end"}>
                                            <P size={16} weight={700}>{addCommas(orderData?.total)} </P>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>

                            </VerticalFlex>
                        </div>
                    </FlexChild>
                    <FlexChild>
                        <Dummy height={"30px"} />
                    </FlexChild>
                    <FlexChild>
                        <div style={{ backgroundColor: "white", padding: "15px", borderRadius: "10px" }}>
                            <VerticalFlex flexStart gap={15}>
                                <FlexChild>
                                    <P weight={700}>{orderData?.shipping_address.first_name}</P>
                                    <P>{"(" + (orderData?.shipping_address.address_2) + ") " + (orderData?.shipping_address.address_1)}</P>
                                    <P>{orderData?.shipping_address.phone}</P>
                                </FlexChild>
                                <FlexChild>
                                    <div style={{ width: "100%", height: "1px", backgroundColor: "#ddd" }} />
                                </FlexChild>
                                <FlexChild>
                                    <P>메모 : {orderData?.message}</P>
                                </FlexChild>
                            </VerticalFlex>
                        </div>
                    </FlexChild>
                    <FlexChild>
                        <Dummy height={"30px"} />
                    </FlexChild>
                    <FlexChild>
                        <VerticalFlex gap={20}>
                            {orderData?.items.map((row, index) => (
                                <div style={{ backgroundColor: "white", padding: "15px", borderRadius: "10px" }} key={index}>
                                    <FlexChild padding={"10px"}>
                                        <div>
                                            <VerticalFlex gap={5}>
                                                <FlexChild>
                                                    <HorizontalFlex>
                                                        <FlexChild>
                                                            <P weight={"bold"} color={"black"} size={16}>
                                                                {t(getDisplayStatus(
                                                                    orderData.status,
                                                                    orderData.payment_status,
                                                                    orderData.fulfillment_status
                                                                ))}
                                                            </P>
                                                        </FlexChild>
                                                    </HorizontalFlex>
                                                </FlexChild>
                                                <FlexChild>
                                                    <div style={{ width: "100%", height: "0.5px", backgroundColor: "#ddd" }} />
                                                    <Dummy height={"5px"} />
                                                </FlexChild>
                                                <FlexChild>
                                                    <HorizontalFlex gap={15}>
                                                        <FlexChild width={"max-content"}>
                                                            <img
                                                                width={"70px"}
                                                                src={row.thumbnail}
                                                            />
                                                        </FlexChild>
                                                        <FlexChild>
                                                            <VerticalFlex flexStart gap={5}>
                                                                <FlexChild>
                                                                    <HorizontalFlex gap={10}>
                                                                        <FlexChild width={"max-content"}>
                                                                            <P>{row.title}</P>
                                                                        </FlexChild>
                                                                        <FlexChild>
                                                                            {row.free &&
                                                                                <div style={{ backgroundColor: "var(--main-color)", width: "max-content", padding: "3px 7px", borderRadius: "5px" }}>
                                                                                    <Center>
                                                                                        <P size={10} color={"white"}>사은품</P>
                                                                                    </Center>
                                                                                </div>
                                                                            }
                                                                        </FlexChild>
                                                                    </HorizontalFlex>
                                                                </FlexChild>
                                                                <FlexChild>
                                                                    <HorizontalFlex>
                                                                        <FlexChild>
                                                                            <P>
                                                                                {row.description} X {row.quantity}
                                                                            </P>
                                                                        </FlexChild>
                                                                    </HorizontalFlex>
                                                                </FlexChild>
                                                                <FlexChild
                                                                    alignItems={"flex-start"}
                                                                    justifyContent={"flex-start"}
                                                                >
                                                                    <P
                                                                        weight={"bold"}
                                                                        color={"var(--main-color)"}
                                                                    >
                                                                        &#8361;{addCommas(row.total)}
                                                                    </P>
                                                                </FlexChild>
                                                            </VerticalFlex>
                                                        </FlexChild>
                                                    </HorizontalFlex>
                                                    <Dummy height={"5px"} />
                                                </FlexChild>
                                                <FlexChild>
                                                    <HorizontalFlex>
                                                        <FlexChild width={"48%"}>
                                                            <div style={{ border: "1px solid #ccc", borderRadius: "3px", height: "30px" }}>
                                                                <Center>
                                                                    <P color={"#ccc"}>교환,반품 신청</P>
                                                                </Center>
                                                            </div>
                                                        </FlexChild>
                                                        <FlexChild width={"48%"}>

                                                            {
                                                                (orderData && (orderData.status === "배송 중" || orderData && orderData.status === "completed")) ?
                                                                    <div onClick={() => onShippingStatusClick(orderData)} style={{ border: "1.2px solid var(--main-color)", borderRadius: "3px", height: "30px" }}>
                                                                        <Center>
                                                                            <P weight={500} color={"var(--main-color)"}>배송조회</P>
                                                                        </Center>
                                                                    </div>
                                                                    :
                                                                    <div style={{ border: "1.2px solid #eee", borderRadius: "3px", height: "30px" }}>
                                                                        <Center>
                                                                            <P weight={500} color={"#eee"}>배송조회</P>
                                                                        </Center>
                                                                    </div>
                                                            }
                                                        </FlexChild>
                                                    </HorizontalFlex>
                                                </FlexChild>
                                            </VerticalFlex>
                                        </div>
                                    </FlexChild>
                                </div>
                            ))}

                        </VerticalFlex>
                    </FlexChild>
                    <FlexChild>
                        <Dummy height={30} />
                        {canCancelOrder && (
                                <div
                                    onClick={onCancelOrder}
                                    style={{
                                        cursor: "pointer",
                                        width: "70%",
                                        height: "50px",
                                        backgroundColor: "var(--main-color)",
                                        borderRadius: "5px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}
                                >
                                    <P color={"white"}>{t("주문취소")}</P>
                                </div>
                        )}
                    </FlexChild>
                </VerticalFlex>
            </Container>
        </Container>
    );
}

export default MobileTrackOrderDetail;